/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {
    AlertConfigSummaryContract
} from '../../../../api/ms-settings/alerts-config/contracts/alert-config-summary.contract';
import {AlertConfigSummaryModel} from '../models/alert-config-summary.model';
import {TableLineModel} from '../../../../shared/table/models/table-line.model';
import {AlertsColumnEnum} from '../models/alerts-column.enum';
import {TableLineDataModel} from '../../../../shared/table/models/table-line-data.model';
import {
    AlertConfigDetailContract
} from '../../../../api/ms-settings/alerts-config/contracts/alert-config-detail.contract';
import {EditAlertConfigDataModel} from '../models/edit-alert-config-data.model';

export class AlertsConfigTableMapper {

    static fromAlertConfigSummaryContractArray(input: AlertConfigSummaryContract[]):
        TableLineModel<AlertsColumnEnum, AlertConfigSummaryModel>[] {
        let lines: TableLineModel<AlertsColumnEnum, AlertConfigSummaryModel>[] = [];

        if (input != null) {
            lines = input.map((alertConfig) => ({
                version: null,
                isOpen: false,
                data: this.fromAlertConfigSummaryContract(alertConfig),
                identifier: alertConfig.code
            }));
        }
        return lines;
    }

    static fromAlertConfigSummaryContract(data: AlertConfigSummaryContract):
        Map<AlertsColumnEnum, TableLineDataModel> {
        const map = new Map<AlertsColumnEnum, TableLineDataModel>([
            [
                AlertsColumnEnum.NAME, {cellValue: data.name}
            ],
            [
                AlertsColumnEnum.DESCRIPTION, {cellValue: data.description}
            ],
            [
                AlertsColumnEnum.STARTS_ON, {cellValue: data.startsOn}
            ],
            [
                AlertsColumnEnum.ENDS_ON, {cellValue: data.endsOn}
            ],
            [
                AlertsColumnEnum.CREATED_BY, {cellValue: data.createdBy}
            ],
            [
                AlertsColumnEnum.CREATED_ON, {cellValue: data.createdOn}
            ],
            [
                AlertsColumnEnum.UPDATED_BY, {cellValue: data.updatedBy}
            ],
            [
                AlertsColumnEnum.UPDATED_ON, {cellValue: data.updatedOn}
            ],
            [
                AlertsColumnEnum.ACTIVE, {
                cellValue: data.active,
                dotClass: this.fromActiveStatusToClassStyleName(data.active)
            }
            ]
        ]);

        return map;
    }

    static fromActiveStatusToClassStyleName(data: boolean): string {
        return data ? 'alerts-config ACTIVE' : 'alerts-config INACTIVE';
    }

    static fromAlertConfigDetailContractToEditAlertConfigModel(data: AlertConfigDetailContract): EditAlertConfigDataModel {
        if (data != null) {
            return {
                active: data.active,
                name: data.name,
                description: data.description,
                scheduled: data.scheduled,
                startsOn: data?.startsOn,
                endsOn: data?.endsOn,
                updatedBy: data.updatedBy,
                updatedOn: data.updatedOn
            };
        }
    }
}
